"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const recharts_1 = require("recharts");
const themes_1 = require("@/theme/themes");
const Loading_1 = require("../layout/Loading");
const CustomChartToolTip_1 = __importDefault(require("./CustomChartToolTip"));
const styledComponents_1 = require("../styledComponents");
const CustomBarChart = ({ data, isPageLoading, yAxisUnit, col, chartTitle, yAxisdivider, tooltipPayload, }) => {
    const [width, setWidth] = (0, react_1.useState)(window.innerWidth);
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const handleResize = () => {
        setWidth(window.innerWidth);
    };
    if (data && !isPageLoading) {
        return (react_1.default.createElement(styledComponents_1.ChartContainer, { col: col },
            react_1.default.createElement(styledComponents_1.CustomCardHeader, null, chartTitle),
            react_1.default.createElement(styledComponents_1.GridChartInner, null,
                react_1.default.createElement(recharts_1.ResponsiveContainer, null,
                    react_1.default.createElement(recharts_1.BarChart, { data: data },
                        react_1.default.createElement(recharts_1.CartesianGrid, { vertical: false, stroke: '#363636' }),
                        react_1.default.createElement(recharts_1.Tooltip, { position: width > 600 ? null : { x: 0, y: -140 }, wrapperStyle: { outline: 'none' }, content: react_1.default.createElement(CustomChartToolTip_1.default, { data: data, customPayload: tooltipPayload ? tooltipPayload : data }) }),
                        Object.getOwnPropertyNames(data[0]).map((e, i) => {
                            if (e !== 'date') {
                                return react_1.default.createElement(recharts_1.Bar, { key: i, dataKey: e, fill: themes_1.darkTheme.colors.charts[0], barSize: 1 });
                            }
                        }),
                        react_1.default.createElement(recharts_1.XAxis, { dataKey: 'date', tick: { fontSize: '0.7em' } }),
                        react_1.default.createElement(recharts_1.YAxis, { unit: yAxisUnit, tick: {
                                fontSize: '0.7em',
                            }, tickFormatter: (value) => (Number(value.toFixed(0)) / (yAxisdivider ? yAxisdivider : 1)).toString() }))))));
    }
    else
        return (react_1.default.createElement(styledComponents_1.ChartContainer, { col: col },
            react_1.default.createElement(styledComponents_1.ChartLoading, null,
                react_1.default.createElement(Loading_1.Loading, null))));
};
exports.default = CustomBarChart;
